<template>
  <form @submit.prevent="submit">
    <Field
      type="select"
      :options="companies"
      label="Company name"
      @input="$v.resource.companyId.$touch()"
      v-model="resource.companyId"
      :error="companyIdError"
    />

    <Field
      type="select"
      :options="websites"
      label="Website"
      @input="$v.resource.siteId.$touch()"
      v-model="resource.siteId"
      :error="siteIdError"
    />

    <Field
      label="Domain"
      @input="$v.resource.domain.$touch()"
      v-model="resource.domain"
      :error="domainError"
    />

    <div class="btn-save">
      <btn primary :disabled="$v.$invalid">Generate</btn>
    </div>
  </form>
</template>

<script>
import form from '@/mixins/form'
import Btn from '@/components/Btn'

import {errorMessages} from '@/lib/error_messages'
import {required} from 'vuelidate/lib/validators'

export default {
  name: 'CreateCertificateForm',

  mixins: [form],

  props: {
    companies: {
      type: Array,
      required: true
    },

    websites: {
      type: Array,
      required: true
    }
  },

  components: {
    Btn
  },

  computed: {
    ...errorMessages([
      'companyId',
      'siteId',
      'domain'
    ])
  },

  validations: {
    resource: {
      companyId: {required},
      siteId: {required},
      domain: {required}
    }
  }
}
</script>

<style lang="sass">
  .admin-website-pages

</style>
